<template>
  <div class="row drag-tab-container">
    <div class="col-xs-11 col-sm-11 col-lg-11 col-xl-11">
      <drag-tab
        v-for="tab in tabs"
        :key="tab.name"
        :tab="tab"
        :tabs="tabs"
      />
    </div>
    <div class="col-xs-1 col-sm-1 col-lg-1 col-xl-1">
      <button class="btn-plus" @click="addTab">+</button>
    </div>
  </div>
</template>
<script>
import DragTab from '@/components/helpers/DragNDrop/DragTab'
export default {
  props: {
    tabs: {
      type: Array,
      required: true
    },
    editorName: {
      type: String
    },
  },
  components: {
    DragTab
  },
  computed: {
    activeTab() {
      return this.$store.getters.getDragEditorActiveTab
    }
  },
  async mounted() {
    // For some reason won't work without this. Probably has to do with
    // the tabs being set empty first and then become filled in afterwards
    this.setFirstTabActive()
  },
  methods: {
    setFirstTabActive() {
      // if we are in Lead Sheet Editor we have to ignore the main_tab and switch to the first tab instead
      if (this.editorName == 'LeadMask') {
        this.$store.commit('SET_DRAG_EDITOR_ACTIVE', this.tabs[0])
        this.$store.commit('SET_DRAG_EDITOR_ACTIVE_TAB', this.tabs[0])
      } else {
        this.$store.commit('SET_DRAG_EDITOR_ACTIVE', this.activeTab)
        this.$store.commit('SET_DRAG_EDITOR_ACTIVE_TAB', this.activeTab)
      }
    },
    addTab() {

      let random_tab_name = `${Math.random().toString(36).substring(7)}_tab`

      let position_last_item = parseInt(this.tabs.length)
      let item = {
        element_type: "container_tab",
        name: random_tab_name,
        parent_element: "root",
        label: `Tab ${position_last_item + 1}`
      }

      this.tabs.push(item)
    }
  },
}
</script>
<style lang="sass" scoped>
.drag-tab-container
  padding-bottom: 20px
  margin-top: -10px

.btn-plus
  border: 2px dashed $sensual-light
  background: white
  border-radius: 5px
  padding-left: 7px
  padding-top: 6px
  width: 40px
  height: 40px
  font-size: 28px
  line-height: 24px
  color: $sensual
  cursor: pointer
  transition: all .15s ease-out
  margin-top: 10px
  &:hover
    border: 2px dashed $sensual !important

.q-btn-group.row.no-wrap.inline.q-btn-dropdown.q-btn-dropdown-split.no-wrap.q-btn-item
  background: $paper-lighter
  border: 2px solid $paper-light
  border-radius: 20px
  box-shadow: none !important
  color: $ink
  margin-right: 10px
  &:hover
    background-color: none !important
.q-btn
  background: $paper-lighter !important
  border: 2px solid $paper-light !important
  border-radius: 20px !important

</style>



// WEBPACK FOOTER //
// DragTabContainer.vue?7cc271be